export default __webpack_public_path__ + "static/Richard-Reuben-42995991fe8d24d0ae732f84f82062e8.png";